// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ThMfNJJgMHhydSAMUBZGW","visible":"_37WKzZkuOjrqMVCyE6b3E-","cancelBtn":"_1IrFUGhu8ohcq4oDjXcwNt","icon":"_35VZx31A-8l2ka1DT4yVxQ","saveBtn":"XlYL_WqgvClfdRM8IdwTK"};